/**
 * 통합검색(search-all) React Query 키.
 *
 * ## 규약
 * - 키 모양은 `[도메인, 조회이름, …인자를 «값으로» 펼친 것]` — 객체를 통째로 넣지 않는다.
 * - 인자는 `toMediaScopeKey(filter)` 한 줄이다 — 「다시 조회해야 하는가」와 캐시 정체성이 같다.
 * - 페이지는 키에 넣지 않는다 — 이어 불러오기(`useInfiniteQuery`)가 한 키 아래 페이지를 쌓는다.
 */
export const searchAllKeys = {
  all: ['search-all'] as const,

  /** @param scopeKey `toMediaScopeKey(filter)` · @param size 한 페이지 수(둘 다 펼 때 반) */
  mediaAds: (scopeKey: string, size: number) => [...searchAllKeys.all, 'media-ads', scopeKey, size] as const,
  /** @param scopeKey `toMediaScopeKey(filter)` · @param size 한 페이지 수 · @param documentLimit 플랜 문서 상한 */
  mediaOrganic: (scopeKey: string, size: number, documentLimit: number) =>
    [...searchAllKeys.all, 'media-organic', scopeKey, size, documentLimit] as const,
  /** @param query 확정 검색어 · @param sort 상품 정렬 — 상품 탭(판매몰 랭킹 검색) */
  products: (query: string, sort: string) => [...searchAllKeys.all, 'products', query, sort] as const,
  /** @param key `ad:<id>` 또는 `img:<썸네일 주소>` — 비슷한 이미지의 광고 소재 */
  similarAds: (key: string) => [...searchAllKeys.all, 'similar-ads', key] as const,
  /** @param key `post:<게시물 id>` 또는 `img:<소재 이미지 주소>` — 비슷한 이미지의 소셜 게시물 */
  similarPosts: (key: string) => [...searchAllKeys.all, 'similar-posts', key] as const,
  /** @param adId 광고 id(adArchiveId) — 상세 다이얼로그가 여는 광고 원본 */
  adDetail: (adId: string) => [...searchAllKeys.all, 'ad-detail', adId] as const,
  /** @param seq 들고 있는 이미지 번호 — 이미지를 바꿀 때마다 오른다(파일은 키에 넣지 않는다) */
  imageSearch: (seq: number) => [...searchAllKeys.all, 'image-search', seq] as const,
  /** @param idsKey 인플루언서 문서 id 를 정렬해 이은 것 — 계정이 같으면 같은 질문 */
  accountProfiles: (idsKey: string) => [...searchAllKeys.all, 'account-profiles', idsKey] as const,
};
